import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const aiPrincipleDefinition: ResourceDefinition = {
  title: 'AI Principles',
  nameSingular: 'AI Principle',
  namePlural: 'AI Principles',
  className: 'AIPrinciple',
  mainIdentifier: 'name',
  slug: 'taxonomies/ai-principles',
  path: 'ai-principles',
  icon: 'icon-tag',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editPolicyInitiativeTaxonomies',
      action: (aiPrinciple) => ({
        type: ActionType.Link,
        link: {
          path: `${aiPrincipleDefinition.path}/${aiPrinciple.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deletePolicyInitiativeTaxonomies',
      action: (aiPrinciple) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: aiPrinciple,
          definition: aiPrincipleDefinition
        }
      })
    }
  ]
}
